import {Modal, PageTitle, Table} from "@/theme";
import style from './style.module.scss'
import {Tag} from "antd";
import cn from "classnames/bind";
import {dateFormat} from "@/lib/utils";
import {useApi} from "@/lib/hook";
import {UserBackups} from "./userBackups";

export const UserDetailsModal = ({isModalOpen, setIsModalOpen, userId}) =>{
    const {data: user, isFetching} = useApi({
        route: {name: 'user.id', query:{id: userId}},
        setting: {
            enabled: Boolean(userId),
            select: (resp) => resp.data
        }
    })

    const {data: subscriptionHistory} = useApi({
        route: {name: 'user.subscription.history', query:{id: userId}},
        setting: {
            enabled: Boolean(userId),
            select: (resp) => resp.data
        }
    })

    return(
        <>
            <Modal
                loading={isFetching}
                open={isModalOpen}
                onCancel={setIsModalOpen}
                title={'User details'}
                footer={null}
                width={992}
            >
               <div className={style.user_details}>
                   <Info
                       user={user}
                   />
                   <Subscription
                       subscription={user?.subscription}
                   />
                   <SubscriptionHistory data={subscriptionHistory}/>
                   <UserBackups userId={userId}/>
               </div>
            </Modal>
        </>
    )
}

const Info = ({user}) =>{
    return(
        <>
            <PageTitle
                title={'User info'}
                middle
            />

            <div className={style.card}>
                <div className={style.input}>
                    <div className={style.label}>
                        Full name
                    </div>
                    <div className={style.value}>
                        {user.first_name} {user.last_name}
                    </div>
                </div>
                <div className={style.input}>
                    <div className={style.label}>
                        Email
                    </div>
                    <div className={style.value}>
                        {user.email}
                    </div>
                </div>
                {/*<div className={style.input}>*/}
                {/*    <div className={style.label}>*/}
                {/*        Authorization*/}
                {/*    </div>*/}
                {/*    <div className={style.value}>*/}
                {/*        Allowed*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </>
    )
}

const Subscription = ({subscription}) =>{
    return(
        <>
            <PageTitle
                title={'Subscription info'}
                middle
            />

            <div className={style.card}>
                <div className={style.input}>
                    <div className={cn(style.label, style.bold)}>
                        Current plan
                    </div>
                    <span className={cn(style.value, style.fz16)}>
                        {subscription.plan}
                    </span>
                    <span className={cn(style.value, style.regular, style.fz16)}>
                        &nbsp;{subscription.billing_interval} / {subscription.billing_period}
                    </span>
                </div>
                <div className={style.input}>
                    <div className={cn(style.label, style.bold)}>
                        Date of start
                    </div>
                    <div className={cn(style.value, style.regular)}>
                        {dateFormat(subscription.schedule_start)}
                    </div>
                </div>
                <div className={style.input}>
                    <div className={cn(style.label, style.bold)}>
                        Date of end
                    </div>
                    <div className={cn(style.value, style.regular)}>
                        {dateFormat(subscription.schedule_next_payment)}
                    </div>
                </div>
                <div className={style.input}>
                    {(subscription.is_active)
                        ? (
                            <Tag
                                bordered={false}
                                color="green"
                            >
                                Active
                            </Tag>
                        )
                        : (
                            <Tag
                                bordered={false}
                                color="error"
                            >
                                Expired
                            </Tag>
                        )
                    }
                </div>
            </div>
        </>
    )
}

const SubscriptionHistory = ({ data }) => {
    const columns = [
        {
            title: 'Subscription ID',
            dataIndex: 'id',
            width: '120px',
            render: (text, record) => record.sub_id
        },
        {
            title: 'Subscription type',
            width: '230px',
            render: (item) => (
                <>
                    <div className="fw_bold">
                        {item.product_title}
                    </div>
                    <div className="fz_11">
                       {item.billing_interval} / {item.billing_period}
                    </div>
                </>
            )
        },
        {
            title: 'Date of start',
            dataIndex: 'schedule_start',
            width: '120px',
        },
        {
            title: 'Next payment',
            dataIndex: 'schedule_next_payment',
            width: '120px',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: '100px',
            render: (status) => (
                <Tag
                    bordered={false}
                    color={status === 'active' ? 'green' : status === 'on-hold' ? 'orange' : 'red'}
                >
                    {status}
                </Tag>
            )
        },
        {
            title: 'Event',
            dataIndex: 'event',
            width: '160px',
        },
    ];

    return (
        <>
            <PageTitle
                title={'History'}
                middle
            />
            <Table
                style={{ marginTop: 16 }}
                dataSource={data}
                columns={columns}
                rowKey={'id'}
            />
        </>
    );
}
